module.exports = __webpack_public_path__ + "static/media/privacy-tip.0b1259ab.svg";